import { createSlice } from '@reduxjs/toolkit';

const creditsSlice = createSlice({
  name: 'credits',
  initialState: {
    balance: 0,
    monthlyAllocation: 0,
    planType: null,
    nextResetAt: null,
    isLoading: false,
  },
  reducers: {
    setCreditsData(state, action) {
      const { balance, monthlyAllocation, planType, nextResetAt } = action.payload;
      state.balance = balance ?? state.balance;
      state.monthlyAllocation = monthlyAllocation ?? state.monthlyAllocation;
      state.planType = planType ?? state.planType;
      state.nextResetAt = nextResetAt ?? state.nextResetAt;
      state.isLoading = false;
    },
    resetCredits(state) {
      state.balance = 0;
      state.monthlyAllocation = 0;
      state.planType = null;
      state.nextResetAt = null;
      state.isLoading = false;
    },
  },
});

export const { setCreditsData, resetCredits } = creditsSlice.actions;
export default creditsSlice.reducer;
